import React, { useEffect, useState } from "react";
import axios from "axios";
import { api } from "../Api";
import "../assets/ProfileCard.css";

const ProfileCard = (props) => {
  const embeddedUser = props.withdrawId && typeof props.withdrawId === "object" ? props.withdrawId : null;
  const userId = embeddedUser?._id || props.withdrawId || props.sourceUserId;
  const [userData, setUserData] = useState(embeddedUser);
  const sourceTotal = Number(props.sourceWithdrawAmount || props.grossAmount || 0);
  const earned = Number(props.amount || 0);

  useEffect(() => {
    if (embeddedUser) {
      setUserData(embeddedUser);
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          api + `/api/users/getIncomeGenerationHistoryUser/${userId}`,
          props.token ? { headers: { Authorization: `Bearer ${props.token}` } } : undefined
        );
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (userId) fetchUserData();
  }, [embeddedUser, props.token, userId]);

  return (
    <div className="col-md-4">
      {userData ? (
        <div className="box1 box">
          <div className="content">
            <div className="image">
              <img
                src={userData.profilePhoto || "https://i.postimg.cc/bryMmCQB/profile-image.jpg"}
                alt="Profile"
              />
            </div>
            <div className="text">
              <p className="name">{userData.name}</p>
              <p className="job_title">{userData.username}</p>
            </div>
            <div className="button">
              <div>
                <button className="message" type="button">
                  {sourceTotal > 0 ? sourceTotal.toFixed(2) : "N/A"} <br /> Source Withdraw
                </button>
              </div>
              <div>
                <button className="connect" type="button">
                  {earned.toFixed(2)} <br /> Your Earnings
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>NO User Information Found. {userId}</p>
      )}
    </div>
  );
};

export default ProfileCard;
